// --------------------------------------------------------------
// Created On: 2025-11-05
// Author: Marco Serrano
//
// Last Modified: 2025-11-19
// Modified By: Marco Serrano
//
// Copyright 2025 © Cornell Pump Company, All Rights Reserved
// --------------------------------------------------------------

import { API } from "../constants/miscellaneous";
import apiRequest from "./api/apiRequest";
import getApiError from "./api/getApiError";

// Wrapper function for behavior related to clearing the cart.
export function clearCartManager(
  onCartItemsChange: (cartItems: CartItem[]) => void,
  onLoadingChange: (loading: boolean) => void,
  onErrorChange: (error: string) => void
) {
  // Clear the cart of all items and make api request to /cart.
  async function clearCart() {
    onCartItemsChange([]);

    const requestBody = {
      items: [],
      replaceAll: true,
    };

    const [response] = await apiRequest(`${API}/cart`, "PUT", requestBody);

    if (response.ok) {
      onLoadingChange(false);
    } else {
      onErrorChange(await getApiError(response, "Unable to clear cart."));
      onLoadingChange(false);
    }
  }

  return { clearCart };
}

interface CartItem {
  cartItemId: number;
  name: string;
  partId: number;
  partNumber: string;
  isPaintable: boolean;
  paintColorId: number | null;
  quantity: string;
  quantityIsValid: boolean;
  units: string;
  price: number | null;
  weight: number | null;
  impellerTrim: string | null;
  impellerTrimIsValid: boolean;
  impellerAngle: string | null;
  impellerAngleIsValid: boolean;
  dateAvailable: string | null;
}
